import _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import * as BasketRaffleActions from './basketRaffle.actions';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export const basketRaffleFeatureKey = 'basketRaffle';

export interface State extends EntityState<any> {
  search: string;
  selected: any;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialState: State = adapter.getInitialState({
  search: '',
  selected: null
});

export const reducer = createReducer(
  initialState,

  on(BasketRaffleActions.loadBasketRaffleList, (state) => state),
  on(BasketRaffleActions.loadBasketRaffleListSuccess, (state, action) => {
    return adapter.upsertMany(action.data, adapter.removeAll(state));
  }),
  on(BasketRaffleActions.loadBasketRaffleListFailure, state => state),

  on(BasketRaffleActions.createBasketRaffleItem, (state) => state),
  on(BasketRaffleActions.createBasketRaffleItemSuccess, (state, { data: basketItem }) => {
    return adapter.upsertOne(basketItem, state);
  }),
  on(BasketRaffleActions.createBasketRaffleItemFailure, state => state),

  on(BasketRaffleActions.updateBasketRaffleItem, (state) => state),
  on(BasketRaffleActions.updateBasketRaffleItemSuccess, (state, { basketItem }) => {
    return adapter.updateOne({
        id: basketItem.id,
        changes: basketItem
    }, state);
  }),
  on(BasketRaffleActions.updateBasketRaffleItemFailure, state => state),

  on(BasketRaffleActions.updateBasketRaffleList, (state) => state),
  on(BasketRaffleActions.updateBasketRaffleListSuccess, (state, { basketItems }) => {
    return adapter.upsertMany(basketItems, adapter.removeAll(state));
  }),
  on(BasketRaffleActions.updateBasketRaffleListFailure, state => state),

  on(BasketRaffleActions.deleteBasketRaffleItems, (state) => state),
  on(BasketRaffleActions.deleteBasketRaffleItemsSuccess, (state, { basketItemIds }) => {
    return adapter.removeMany(basketItemIds, state);
  }),
  on(BasketRaffleActions.deleteBasketRaffleItemsFailure, state => state),

  on(BasketRaffleActions.resetBasketRaffleItemList, state => adapter.removeAll(state))
);
